<template>
  <div class="container-fluid">
    <net-pa-card>
      <template v-slot:header>
        <h6 class="text-right"><i class="fas fa-cheque ml-2"></i> بررسی وضعیت خرید سفته</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div v-if="Loading" class="col-12 m-3 text-center">
            <p class="h4">
              {{ 'در حال بررسی و ثبت مشخصات پرداختی سفته ' }}
            </p>
            <Spinner class="text-center pt-5" name="line-scale-pulse-out-rapid" color="#5274eb" />
          </div>
          <div v-if="!Loading && Success" class="col-12 m-3 text-center"></div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../../Tools/NetPa/NetPaCard.vue'
export default {
  components: { NetPaCard },
  data() {
    return {
      Safte_request_Id: '',
      Paymanent_Id: '',
      Loading: true,
      Success: false,
    }
  },
  created() {
    this.Paymanent_Id = this.$route.query.id
    this.Safte_request_Id = this.$route.query.request_id
    this.SubmitPayment()
  },
  methods: {
    SubmitPayment() {
      var DataAxios = {
        Method: 'POST',
        Action: 'ElectronicSafte/Status_Pay',
        ArryfildValue: {
          BnpInfo: {
            CustCode: this.$session.get('CustCode'),
            BnpToken: this.$session.get('TokenNetPa'),
            LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
          },
          payment_id: this.Paymanent_Id,
          request_id: this.Safte_request_Id,
        },
      }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'success') {
          this.Loading = false
          this.Success = true
        }
      })
    },
  },
}
</script>
